import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";


export const Content = styled.div`
    width:100%;
    padding:1.2rem 2rem;
    background:#fff;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    height:75vh;
    margin-top: 1rem;
    position: relative;
`;

export const TitleLeft = styled.div`
    display:flex;
    flex-direction: row;
    gap:1rem;
    justify-content: space-between;
    align-self: end;
    span:nth-of-type(1){
        font-size: 20px;
        font-weight: 600;
    }
    span:nth-of-type(2){
        color:#414141;
        font-size: 14px;
        font-weight: 500;
        height: 100%;
        margin-top: auto;
    }
`;


export const DataListWrap = styled.div`
    height:calc(100% - 98px );
    overflow:auto;  
    scrollbar-width: thin;

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background-color: darkgrey;
    }
    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
`;

export const DashList = styled.table`
    width:100%;
    margin-top: 1rem;
    border-collapse: collapse;

    td{
        font-size: 14px;
        padding:5px 10px;

        &:last-of-type{
            text-align: right;
        }
    }

    tr:nth-of-type(even){
            background:#a7a7a71f;
    }

    span{
        display:block;
        white-space: nowrap;
    }

    .width50{
        width:100%;
    }

    .width20{
        min-width:180px;
    }

    .mHover{
        cursor:pointer;
    }
`;

export const Td = styled.td<{}>`
    font-size: 16px !important;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    white-space: nowrap;

    &:hover{
        background:#f8f8f8;
    }

    > div{
        display:flex;
        gap:6px;
        align-items: center;
    }
`;

export const QuestMark = styled.div`
    width:14px;
    height:14px;
    border-radius: 100%;
    display:flex;
    align-items: center;
    justify-content: center;

    svg{
        height:100%;
        path{
            fill:#b8b8b8;
        }
    }
`;


export const FlexRow = styled.div`
    display:flex;
    gap:8px;
    justify-content: end;
`;

export const CheckRow = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
    gap:6px;
    color:#a0a0a0;

    svg{
        height:12px;
        path{
            fill:#a0a0a0;
        }
    }
`;

export const Img = styled.div`
    width:28px;
    height:28px; 
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 0 2px rgba(0,0,0,0.25);
`;

export const ActionBar = styled.div`
    display:flex;
    gap:1rem;
    margin-left: auto;
    justify-content: end;

    > div{
        display:flex;
        align-items: center;
    }

    svg{
        cursor: pointer;
        width:18px;

        path{
            fill:#888888;
        }

        :hover{
            opacity: 0.8;
        }
    }
`;

export const PopupContent = styled.div`
    padding:1rem 1.5rem 0.5rem 1.5rem;

    > span{
        display:block;
        font-size: 16px;
    }

    > p{
        font-size: 16px;
        margin-bottom: 1rem;
        margin-top: 0.2rem;
    }

    textarea{
        font-size: 14px;
        width:100%;
        height:90px;
        resize: none;
        border-radius: 5px;
        padding:1rem;
        outline:none;
        border-color:#acacac;
    }
`;

export const Text = styled.p`
    font-size: 18px;
    margin: 0 0 20px 0;
`;

export const DateSelectContainer = styled.div<{ span?: boolean }>`
    width:100%;
    display:grid;
    grid-template-columns: 1fr 1fr;
    gap:10px;
    margin-bottom: 12px;
    position: relative;
    align-items: center;
    
    > div{
        margin-left: auto;
    }
`;

export const DateSelector = styled.div`
    height:28px;
    border:1px solid #2A848E;
    border-radius: 5px;
    display:flex;
    align-items:center;
    justify-content: end;
    gap:8px;
    padding:0 12px;

    span{
        color:#2A848E;
        font-size: 14px;
        font-weight: 600;
        width:auto; 
    }

    svg{
        margin-left: auto;
        height:70%;
    }
`;

export const SubTitle = styled.span<{ marginRight?: boolean }>`
    font-size: 16px;
    font-weight: 500;
    margin-right: ${props => props.marginRight ? "auto" : "0"};
    display:block;
`;

export const ButtonContainer = styled.div`
    width:100%;
    display:flex;
    gap:10px;
    margin-top: 12px;
    padding: 0 1.5rem 1rem 1.5rem;

    button{
        font-size: 16px;
        font-weight: 500; 
        width:120px;
        background:#2A848E;
        color:#fff;
        padding:10px 0;
        border-radius: 20px;

        :nth-of-type(1){
            margin-left: auto;
            background:#FA505E;
        }
    }
`;

export const Success = styled.div`
    svg{
    height: 12px;
    path{
        transition: all 0.2s ease-in-out;
    }
}

    `;

export const Message = styled.textarea`
    width:100%;
    border:1px solid #2A848E;
    resize: none;
    height: 110px;
    border-radius: 5px;
    margin-top: 8px;
    outline:none;
    padding:10px;
    color:#3a3a3a;
    font-size: 16px;

    ::-webkit-input-placeholder{
        color:#2A848E;
    }
    ::-moz-placeholder{
        color:#2A848E;
    }
    ::placeholder{
        color:#2A848E;
    }
`;

export const TitleBar = styled.div`
    width:100%;
    padding:8px 20px;
    background:#EBEBEB;
    display:flex;

    span{
        font-size: 22px;
        font-weight: 600;
    }

    > div{
        margin-left: auto;
        background:#2A848E;
        width:32px;
        height:32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        svg{
            width:50%;
            path{
                fill:#fff;
            }
        }
    }
`;